<template>
  <div>
    <div style="font-size: 1.6rem">
      4steps
    </div>
    <div>「作成」のステップがアクティブの場合</div>
    <FlowLineFourSteps :steps="fourSteps" :active-step="1" />
    <div>「プレビュー」のステップがアクティブの場合</div>
    <FlowLineFourSteps :steps="fourSteps" :active-step="2" />
    <div>「確認」のステップがアクティブの場合</div>
    <FlowLineFourSteps :steps="fourSteps" :active-step="3" />
    <div>「完了」のステップがアクティブの場合</div>
    <FlowLineFourSteps :steps="fourSteps" :active-step="4" />
    <div style="font-size: 1.6rem">
      3steps
    </div>
    <div>「入力」のステップがアクティブの場合</div>
    <FlowLineThreeSteps :steps="threeSteps" :active-step="1" />
    <div>「確認」のステップがアクティブの場合</div>
    <FlowLineThreeSteps :steps="threeSteps" :active-step="2" />
    <div>「完了」のステップがアクティブの場合</div>
    <FlowLineThreeSteps :steps="threeSteps" :active-step="3" />
  </div>
</template>
<script>
import FlowLineFourSteps from '../../components/atoms/flow_lines/FlowLineFourSteps.vue'
import FlowLineThreeSteps from '../../components/atoms/flow_lines/FlowLineThreeSteps.vue'

export default {
  components: { FlowLineThreeSteps, FlowLineFourSteps },
  data() {
    return {
      fourSteps: ['作成', 'プレビュー', '確認', '完了'],
      threeSteps: ['入力', '確認', '完了']
    }
  }
}
</script>
